const meta = {
  requiresAuth: false,
  skipOnboarding: true,
  layout: 'focus',
  transition: 't-fade',
  layoutTransition: 't-fade',
  systemBar: { color: 'neutral0' },
}

export default [
  {
    path: '/legal/imprint',
    component: () => import('@/views/Account/Legal/Imprint.vue'),
    meta,
  },
  {
    path: '/legal/tos',
    component: () => import('@/views/Account/Legal/TermsOfService.vue'),
    meta,
  },
  {
    path: '/legal/privacy',
    component: () => import('@/views/Account/Legal/PrivacyPolicy.vue'),
    meta,
  },
  {
    path: '/legal/licenses',
    component: () => import('@/views/Account/Legal/Licenses.vue'),
    meta,
  },
]
